import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import styled from 'styled-components';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
var InputWrapper = styled(Box)(function (_a) {
  var isDisabled = _a.isDisabled,
    isFocused = _a.isFocused,
    isInvalid = _a.isInvalid,
    borderColor = _a.borderColor,
    theme = _a.theme;
  return css({
    boxSizing: "border-box",
    height: "60px",
    borderRadius: "16px",
    boxShadow: "inset 0 0 0 0 rgba(255,255,255,0), inset 0 0 0 ".concat(isFocused ? "2px" : "1px", " ").concat(borderColor || (isInvalid ? theme.colors.red[300] : theme.colors.grey[5]), ", inset 0 0 0 9999px ").concat(theme.colors.base),
    paddingX: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    cursor: isDisabled ? "auto" : "text",
    width: "100%",
    transition: "all 200ms",
    ":hover": {
      boxShadow: isDisabled ? undefined : "inset 0 0 0 0 rgba(255,255,255,0), inset 0 0 0 ".concat(isFocused ? "2px" : "1px", " ").concat(borderColor || (isInvalid ? theme.colors.red[300] : theme.colors.grey[5]), ", inset 0 0 0 9999px ").concat(theme.colors.grey[8])
    }
  });
});
export { InputWrapper };